import { ActionButton } from "../../components/Forms/ActionButton";
import { TextArea } from "../../components/Forms/TextArea";
import Heading from "../../components/Heading";
import { useEffect, useState } from "react";
import InputField from "../../components/Forms/InputField";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from "react-router-dom";
import MediaUpload from "../../components/Forms/MediaUpload";
import { createProductCategory, productCategoryEditView, updateProductCategory } from "../../api/products";
import ActiveStatus from "../../components/Common/ActiveStatus";
import { useHeader } from "../../context/HeaderContext";

const CreateProductOrServiceCategory = () => {

  const { state } = useLocation();
  const navigate = useNavigate();

  const { setHeaderTitle } = useHeader();

  useEffect(() => {
    if (state?._id) {
      setHeaderTitle('Edit Product/Service Category');
    } else {
      setHeaderTitle('Create Product/Service Category');
    }
    return () => {
      setHeaderTitle('');
    };
  }, [setHeaderTitle, state]);

  const [data, setData] = useState([
    { label: 'Name Of Category', placeholder: 'Enter Name Of Category', name: 'name', value: '', type: 'text' },
    { label: 'Description', placeholder: 'Enter Description Of Category', name: 'description', value: '', type: 'textarea' },
  ]);

  const [active, setActive] = useState(true);
  const [image, setImage] = useState(null);
  const [clearMedia, setClearMedia] = useState(false);

  const handleChange = (index, newValue) => {
    setData(prevFields => prevFields.map((field, i) => i === index ? { ...field, value: newValue } : field));
  }

  const handleSubmit = e => {
    e.preventDefault();
    if (state?._id) {
      updateProductCategory(state._id, {
        id: state._id,
        name: data[0].value,
        description: data[1].value,
        active: active,
        file: image
      }, toast, navigate);
    }
    else {
      createProductCategory({
        name: data[0].value,
        description: data[1].value,
        active: active,
        file: image,
      }, toast, navigate);
    }
  }

  useEffect(() => {
    if (image) {
      setClearMedia(false);
    }
  }, [image]);


  useEffect(() => {
    if (state?._id) productCategoryEditView(state._id, data, setData, setActive, setImage, toast);
    // eslint-disable-next-line
  }, []);

  return (
    <form className="flex flex-col w-full font-semibold">

      <div className="flex justify-end mb-3">
        <ActiveStatus active={active} setActive={setActive} />
      </div>

      <section className="flex flex-col justify-center px-5 pt-4 py-9 gap-3 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">

        <div className="flex w-full gap-3">
          <div className="w-full mt-2.5">
            <div className="flex flex-wrap gap-5 items-end w-full justify-between">
              <InputField
                label={data[0].label}
                placeholder={data[0].placeholder}
                name={data[0].name}
                value={data[0].value}
                type={data[0].type}
                onChange={e => handleChange(0, e.target.value)}
              />
            </div>
            <TextArea
              minHeight={'180px'}
              label={data[1].label}
              placeholder={data[1].placeholder}
              name={data[1].name}
              value={data[1].value}
              type={data[1].type}
              onChange={e => handleChange(1, e.target.value)}
            />
          </div>
          {/* Category Logo Section */}
          <div className="mt-0">
            <MediaUpload
              label="Category Logo"
              id="categoryLogo"
              setImageUpload={setImage}
              existingImage={image}
              stateImage={image}
              setStateImageUpload={setImage}
              clearMedia={clearMedia}
              useFileObject={true}
            />
          </div>
        </div>

        <div className="flex mt-10 gap-3 items-center justify-between self-stretch my-auto whitespace-nowrap min-w-[240px] w-full">
          <ActionButton
            variant="reset"
            text="Reset"
            handleSubmit={() => {
              setData([
                { label: 'Name Of Category', placeholder: 'Enter Name Of Category', name: 'name', value: '', type: 'text' },
                { label: 'Description', placeholder: 'Enter Description Of Category', name: 'description', value: '', type: 'textarea' },
              ]);
              setActive(true);
              setImage(null);
              setClearMedia(true);
            }}
          />
          <div className="flex gap-3">
            <ActionButton variant="cancel" text="Cancel" handleSubmit={() => navigate('/products/product-categories/view-product-categories')} />
            <ActionButton variant="submit" text="Submit" handleSubmit={handleSubmit} />
          </div>
        </div>

      </section>
      <ToastContainer
        position="top-right"
      />
    </form>
  );
}

export default CreateProductOrServiceCategory;